export function isReproducingErrorLog(
  reproducingErrorLogId: number | null,
  reproduceErrorLogIdFromUrl: number | null = null
): boolean {
  return reproducingErrorLogId !== null || reproduceErrorLogIdFromUrl !== null;
}
